export default __webpack_public_path__ + "static/media/o2-heel.96c598ff.mp4";